/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';
import { ErrorDetail } from './ErrorDetail';
import { Resource } from './Resource';

export const ProblemResourceRevisionNotFound: core.serialization.ObjectSchema<
    serializers.ProblemResourceRevisionNotFound.Raw,
    Truvity.ProblemResourceRevisionNotFound
> = core.serialization.object({
    actual: core.serialization.number(),
    detail: core.serialization.string().optional(),
    errors: core.serialization.list(ErrorDetail).optional(),
    expected: Resource,
    instance: core.serialization.string().optional(),
    status: core.serialization.number(),
    title: core.serialization.string(),
});

export declare namespace ProblemResourceRevisionNotFound {
    export interface Raw {
        actual: number;
        detail?: string | null;
        errors?: ErrorDetail.Raw[] | null;
        expected: Resource.Raw;
        instance?: string | null;
        status: number;
        title: string;
    }
}
